import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrows",
  "use": "icon-arrows-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-arrows\"><path d=\"M6.223 9.77L3.34 6.886c-.351-.351-.43-.753-.235-1.206.194-.453.54-.68 1.04-.68h5.713c.499 0 .845.227 1.039.68.194.453.116.855-.235 1.206L7.777 9.77a1.15 1.15 0 0 1-.361.25c-.13.055-.268.083-.416.083-.148 0-.287-.028-.416-.083a1.15 1.15 0 0 1-.36-.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol